<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <h1 class="text-h4">{{ pageProps.organisation.name }}</h1>
      <v-btn v-if="pageProps.organisation.can_edit" :href="pageProps.organisation.edit_path">Bearbeiten</v-btn>
    </div>

    <div class="d-flex justify-space-between align-center mb-2">
      <h2 class="text-h5">Benutzer</h2>
      <v-btn v-if="pageProps.organisation.can_invite" color="primary" :href="pageProps.organisation.new_user_path">Benutzer einladen</v-btn>
    </div>

    <v-row>
      <v-col v-for="user in pageProps.users" :key="user.id" cols="12" md="6">
        <v-card>
          <v-card-title>{{ user.email }}</v-card-title>
          <v-card-subtitle>
            <a :href="user.organisation.path">{{ user.organisation.name }}</a>, {{ user.reports_label }}
          </v-card-subtitle>
          <v-card-actions>
            <v-form v-if="user.can_resend" method="post" :action="user.paths.resend">
              <input type="hidden" name="authenticity_token" :value="pageProps.csrfToken">
              <v-btn type="submit" size="small" variant="outlined">Einladung erneut senden</v-btn>
            </v-form>
            <v-form v-if="user.can_destroy" method="post" :action="user.paths.destroy">
              <input type="hidden" name="_method" value="delete">
              <input type="hidden" name="authenticity_token" :value="pageProps.csrfToken">
              <v-btn type="submit" size="small" color="error" variant="outlined">Entfernen</v-btn>
            </v-form>
            <v-spacer />
            <small class="text-medium-emphasis">{{ user.updated_at_label }}</small>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
defineProps({
  pageProps: {
    type: Object,
    required: true,
  },
});
</script>
